import {
  Box,
  Flex,
  Avatar,
  Link,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Stack,
  useColorMode,
  useColorModeValue,
  Center,
  Text,
  IconButton,
  Divider,
  Input,
  useDisclosure,
} from "@chakra-ui/react";
import { db } from "../../utils/init-firebase";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { FaBullhorn, FaMoon, FaSun } from "react-icons/fa";
import { FiBell, FiLogIn, FiMenu, FiMessageSquare } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import EOSMenu from "./EOSMenu";
import ReadNotificationDrawer from "../ReadNotificationDrawer";
import { MessagesPopover } from "../Messages/MessagesPopover";
import FeatureHighlight from "../FeatureHighlight/FeatureHighlight";
import TourHelpButton from "../FeatureTour/TourHelpButton";
import { AppSwitcher } from "@fhl-git/auth";
import { useAppSettings } from "../../hooks/useAppSettings";
import CalculatorSwitcher from "../CPCalc/CalculatorSwitcher";
import { isExternalDemoUser } from "../../utils/demoAccess";

// THIS IS THE TOP BAR
export default function Navbar({ onOpen }) {
  const { colorMode, toggleColorMode } = useColorMode();
  const history = useHistory();
  const location = useLocation();
  const {
    logout,
    currentUser,
    navSize,
    changeNavSize,
    isAdmin,
    SuperAdmin,
    MarketingAdmin,
    newRequests,
    inProgressRequests,
    inProgressCounter,
  } = useAuth();
  const { setupQueueCount, notifications } = useAuth();
  const { isOpen: isMessagesOpen, onOpen: onMessagesOpen, onClose: onMessagesClose } = useDisclosure();

  const isEOS = location.pathname.startsWith('/eos');
  const stickyBg = useColorModeValue('white', 'gray.800');

  let christmasLights = require("../../assets/img/christmas-lights.png");
  let newYearsLights = require("../../assets/img/fireworks.png");

  const { appSettings } = useAppSettings();
  // Compute which apps this user has access to
  const userAllowedApps = appSettings
    .filter(app => app.allowAll || (app.allowedUsers || []).includes(currentUser?.uid))
    .map(app => app.id);

  // External demo accounts (partner test drives): hide internal-only navbar
  // surfaces — staff messaging and the satellite-app switcher. Strictly
  // opt-in flag; regular users are unaffected. See src/utils/demoAccess.js.
  const isExternalDemo = isExternalDemoUser(currentUser);
  const handleNavbarToggle = () => {
    if (navSize == "large") {
      changeNavSize("hidden");
    } else {
      changeNavSize("large");
    }
  };
  function handleClick(path) {
    history.push(path);
  }

  async function handleClickNotification(notification) {
    if (notification.id == "Home") {
      history.push("");
      return;
    }

    if (notification.route) {
      history.push(notification.route);
      return;
    }
    if (notification.path) {
      history.push(notification.path);
      return;
    } else {
      let route = "/in-progress/";
      const docRef = doc(db, "Clients", notification.loanID);
      const docSnap = await getDoc(docRef);
      if (docSnap.data()["Status"] == "Completed") {
        route = "/completed/";
      }
      history.push(route + notification.loanID);
    }
  }

  async function markAllRead() {
    notifications.forEach(async (notification) => {
      await updateDoc(
        doc(db, "users", currentUser.uid, "Notifications", notification.id),
        {
          read: serverTimestamp(),
        }
      );
    });
  }

  return (
    <>
      {/*          <Box  
            backgroundImage={`url( ${newYearsLights} )`}
            backgroundSize='contain'
            backgroundRepeat={'repeat'}
            h='45px'
            mt='-20px'
            opacity={'0.6'}
            >
        
          </Box>  */}
      <Box h={isEOS ? "48px" : undefined}>
        <Box
          pt={1}
          px={3}
          boxShadow="0 6px 6px 0 rgba(0, 0, 0, 0.05)"
          position={isEOS ? "fixed" : "relative"}
          width={isEOS ? "100%" : undefined}
          top={isEOS ? "0" : undefined}
          zIndex={isEOS ? "100" : undefined}
          bg={isEOS ? stickyBg : undefined}
          h={"48px"}
        //mt='-20px'
        >
          <Input style={{ display: "none" }}></Input>
          <Flex alignItems={"center"} justifyContent={"space-between"}>
            <FeatureHighlight
              featureId="sidebar-toggle"
              title="New: Sidebar Toggle"
              message="You can now hide the sidebar to get more screen space! Click this button to toggle the sidebar visibility."
              placement="bottom-start"
            >
              <IconButton
                background="none"
                _hover={{ background: "none" }}
                size="lg"
                display={{ base: "none", md: "flex" }}
                variant="ghost"
                icon={navSize == "small" ? <FiMenu /> : <FiMenu />}
                onClick={handleNavbarToggle}
              />
            </FeatureHighlight>
            <IconButton
              background="none"
              _hover={{ background: "none" }}
              size="lg"
              display={{ base: "flex", md: "none" }}
              icon={navSize == "small" ? <FiMenu /> : <FiMenu />}
              onClick={onOpen}
            />

            {/* EOS Menu - only show when route includes /eos AND on md+ screens (when Sidebar is visible, not DrawerBar) */}
            {location.pathname.includes("/eos") && (
              <Box ml={4} display={{ base: "none", md: "block" }}>
                <EOSMenu />
              </Box>
            )}

            <Flex alignItems={"center"} gap={{ base: 1, sm: 2, md: 3, lg: 5, xl: 7 }}>
              <TourHelpButton />
              <CalculatorSwitcher />
              <Menu>
                {MarketingAdmin && (
                  <IconButton
                    position={"relative"}
                    py={"2"}
                    background={"none"}
                    aria-label={"Setup Queue"}
                    size={"lg"}
                    onClick={() => handleClick("/marketing-requests")}
                    icon={
                      <>
                        <FaBullhorn />
                        {newRequests && newRequests.length > 0 && (
                          <Box
                            as={"span"}
                            color={"white"}
                            position={"absolute"}
                            top={"4px"}
                            left={"4px"}
                            fontSize={"0.8rem"}
                            minWidth={"16px"}
                            height={"18px"}
                            bgColor={"#FB404B"}
                            borderRadius={"3xl"}
                            zIndex={2}
                            p={"1px"}
                          >
                            {newRequests.length}
                          </Box>
                        )}
                        {inProgressCounter > 0 && (
                          <>
                            <Box
                              as={"span"}
                              color={"white"}
                              position={"absolute"}
                              top={"4px"}
                              right={"4px"}
                              fontSize={"0.8rem"}
                              minWidth={"16px"}
                              height={"18px"}
                              bgColor={"orange"}
                              borderRadius={"3xl"}
                              zIndex={2}
                              p={"1px"}
                            >
                              {inProgressCounter}
                            </Box>
                          </>
                        )}
                      </>
                    }
                  />
                )}
                {isAdmin && (
                  <IconButton
                    position={"relative"}
                    py={"2"}
                    background={"none"}
                    aria-label={"Setup Queue"}
                    size={"lg"}
                    onClick={() => handleClick("/setup-queue")}
                    icon={
                      <>
                        <FiLogIn />
                        {setupQueueCount > 0 ? (
                          <Box
                            as={"span"}
                            color={"white"}
                            position={"absolute"}
                            top={"6px"}
                            right={"4px"}
                            fontSize={"0.8rem"}
                            minWidth={"16px"}
                            height={"18px"}
                            bgColor={"#FB404B"}
                            borderRadius={"3xl"}
                            zIndex={2}
                            p={"1px"}
                          >
                            {setupQueueCount}
                          </Box>
                        ) : null}
                      </>
                    }
                  />
                )}
                {!isExternalDemo && (
                  <MessagesPopover
                    isOpen={isMessagesOpen}
                    onOpen={onMessagesOpen}
                    onClose={onMessagesClose}
                  >
                    <IconButton
                      aria-label="Messages"
                      variant="ghost"
                      size="lg"
                      position="relative"
                      icon={
                        <>
                          <FiMessageSquare />
                        </>
                      }
                    />
                  </MessagesPopover>
                )}
                <MenuButton
                  as={IconButton}
                  aria-label="Notifications"
                  variant="ghost"
                  size="lg"
                  icon={
                    <>
                      <FiBell />
                      {notifications && (
                        <>
                          {notifications.length > 0 && (
                            <Box
                              as={"span"}
                              color={"white"}
                              position={"absolute"}
                              top={"6px"}
                              right={"4px"}
                              fontSize={"0.8rem"}
                              minWidth={"16px"}
                              height={"18px"}
                              bgColor={"#FB404B"}
                              borderRadius={"3xl"}
                              zIndex={2}
                              p={"1px"}
                            >
                              {notifications.length}
                            </Box>
                          )}
                        </>
                      )}
                    </>
                  }
                ></MenuButton>
                <MenuList
                  maxH={"35vh"}
                  width={"350px"}
                  overflowX="clip"
                  overflowY={"auto"}
                  zIndex={1500}
                >
                  {notifications && (
                    <>
                      {notifications.length > 0 ? (
                        <>
                          <Center>
                            <Button variant={"ghost"} onClick={markAllRead}>
                              Mark All Read
                            </Button>
                          </Center>

                          {notifications.map((notification) => {
                            return (
                              <>
                                <MenuItem
                                  onClick={() =>
                                    handleClickNotification(notification)
                                  }
                                >
                                  <Avatar
                                    mr={2}
                                    size="md"
                                    src={
                                      notification.user
                                        ? notification.user.photoURL
                                        : "public/fhl-logo.png"
                                    }
                                  />
                                  <Stack spacing="0.5" direction="column">
                                    {notification.notification ? (
                                      <Text fontSize="sm">
                                        {notification.notification}{" "}
                                      </Text>
                                    ) : notification.title ? (
                                      <Text fontSize="sm">
                                        {notification.title}{" "}
                                      </Text>
                                    ) : (
                                      <>
                                        {notification.user && (
                                          <>
                                            {notification.user
                                              .displayName && (
                                                <Text fontSize="sm">
                                                  {
                                                    notification.user
                                                      .displayName
                                                  }
                                                  &nbsp;
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Mentioned You
                                                  </span>
                                                </Text>
                                              )}
                                          </>
                                        )}
                                      </>
                                    )}

                                    <Box
                                      color="gray.500"
                                      letterSpacing="normal"
                                      fontSize={{
                                        base: "10px",
                                        lg: "12px",
                                      }}
                                    >
                                      {notification?.timestamp
                                        ? moment(
                                          notification?.timestamp.toDate()
                                        ).calendar()
                                        : null}
                                    </Box>

                                    <Text fontSize="xs" isTruncated as="em">
                                      {notification.message}
                                    </Text>
                                  </Stack>
                                </MenuItem>
                                <Divider />
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <Text m={5} as="cite">
                            You have no notifcations
                          </Text>
                          <ReadNotificationDrawer />
                        </>
                      )}
                    </>
                  )}
                </MenuList>
              </Menu>

              <Button variant={"ghost"} size="lg" onClick={toggleColorMode}>
                {colorMode === "light" ? <FaMoon /> : <FaSun />}
              </Button>

              {userAllowedApps.length > 0 && !isExternalDemo && (
                <AppSwitcher
                  apps={userAllowedApps}
                  hideMainApp={true}
                  colorMode={colorMode}
                />
              )}

              <Menu>
                <MenuButton
                  as={Button}
                  rounded={"full"}
                  variant={"link"}
                  cursor={"pointer"}
                  minW={0}
                >
                  <Avatar size={"sm"} src={currentUser.photoURL} />
                </MenuButton>
                <MenuList alignItems={"center"} zIndex={1500}>
                  <br />
                  <Center>
                    <Avatar size={"xl"} src={currentUser.photoURL} />
                  </Center>
                  <br />
                  <Center>
                    <Text fontWeight="bold">{currentUser.displayName}</Text>
                  </Center>
                  <br />
                  <MenuDivider />
                  <MenuItem onClick={() => handleClick("/profile")}>
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={async (e) => {
                      e.preventDefault();
                      await logout();
                    }}
                  >
                    <Link to="/logout" />
                    Logout
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Flex>
        </Box>
      </Box>
    </>
  );
}
